import type { ReactElement } from 'react';

type Props = {
  /** 문항이 fieldset 이면 legend, 입력 한 칸이면 label 이어야 화면낭독기가 제목으로 읽는다. */
  as: 'legend' | 'label';
  /** as="label" 일 때 가리킬 입력 칸. */
  htmlFor?: string;
  number: number;
  title: string;
  required: boolean;
};

/** 문항 번호 + 제목. 필수 표시(*)는 눈으로만 보인다 — 읽을 때는 「필수」로 읽힌다. */
export function QuestionTitle({ as, htmlFor, number, title, required }: Props): ReactElement {
  const content = (
    <>
      <span
        aria-hidden="true"
        data-numeric=""
        className="mr-2 inline-flex size-6 items-center justify-center rounded-full bg-foreground font-mono text-[12px] text-background"
      >
        {number}
      </span>
      {title}
      {required ? (
        <>
          <span aria-hidden="true" className="ml-0.5 text-primary">
            *
          </span>
          <span className="sr-only"> (필수)</span>
        </>
      ) : null}
    </>
  );
  const className = 'text-[15px] font-semibold leading-[1.6] tracking-[-0.02em]';

  // legend 는 fieldset 의 flex gap 을 받지 않는다 — 브라우저가 테두리 자리에 따로 그리기 때문이다.
  //   간격을 주지 않으면 제목과 첫 보기가 붙는다. 그래서 제목 쪽에 아래 여백을 직접 둔다.
  return as === 'legend' ? (
    <legend className={`${className} mb-4`}>{content}</legend>
  ) : (
    <label htmlFor={htmlFor} className={className}>
      {content}
    </label>
  );
}
